import { jsxs as f, Fragment as L, jsx as l } from "react/jsx-runtime";
import { forwardRef as T, useRef as q, useState as b, useEffect as H } from "react";
import { ButtonGroup as J } from "@mui/material";
import s from "styled-components";
import K from "../../icons/chevron-down.js";
import "../../theme/themes/AtriusDark.js";
import "../../theme/themes/AtriusLight.js";
import "../../theme/themes/DistechDark.js";
import "../../theme/themes/DistechLight.js";
import "../../theme/themes/DLNLight.js";
import "../../theme/utils/getThemeDefinition.js";
import { getFlavorColor as P, getColorDisabled as Q, variants as x, getBorderColor as N } from "../../theme/utils/styleUtils.js";
import "../../theme/GlobalStyle.js";
import "@emotion/is-prop-valid";
import "@mui/material/styles";
import "lodash/merge";
import "color-convert";
import D from "../Button/Button.js";
import U from "../Menu/Menu.js";
import V from "../Menu/components/MenuItem.js";
import "../Menu/components/MenuList.js";
import X from "../Tooltip/Tooltip.js";
const Y = (o, t, i) => i ? o.text.secondary : P(o, t, "currentColor"), Z = (o, t, i, e) => e ? Q(o, t) : t === x.contained ? o.primaryBorder : t === "text" ? N(o, x.outlined, i) : N(o, t, i), R = (o, t) => o !== void 0 && t.length > o ? o : t.findIndex((i) => i.defaultSelected) !== -1 ? t.findIndex((i) => i.defaultSelected) : 0, _ = s(K).withConfig({
  displayName: "StyledDownIcon"
})([
  "&&&&{height:12px;width:12px;vertical-align:middle;}"
]), $ = s.span.withConfig({
  displayName: "MenuWrapper"
})([
  "display:flex;align-items:center;svg,img,.left-icon{margin-right:8px;}"
]), I = s(V).withConfig({
  displayName: "StyledMenuItem"
})([
  "svg{width:18px;height:18px;color:",
  ";}&:hover svg{color:currentColor;}"
], ({ theme: o, $flavor: t, disabled: i }) => Y(o, t, i)), oo = s(D).withConfig({
  displayName: "RightButton"
})([
  "&&&&&{min-width:34px;padding:8px;border-left-color:",
  ";}svg{transition:transform 0.25s linear;transform:",
  ";}"
], ({ theme: o, variant: t, flavor: i, disabled: e }) => Z(o, t, i, e), ({ $open: o }) => o ? "rotate(180deg)" : "rotate(0deg)"), So = /* @__PURE__ */ T(({ selectedItemIndex: o = void 0, ButtonProps: t = {}, disabled: i = !1, flavor: e = "normal", items: n = [], label: p = void 0, loading: u = !1, loadingSize: O = 24, MenuProps: j = {}, onSelectionChange: g = void 0, LeftButtonProps: z = {}, SelectionButtonProps: A = {}, variant: h = "contained", ...E }, F) => {
  var w, B, M;
  const C = q(null), [m, v] = b(!1), [a, d] = b(R(o, n));
  H(() => {
    o !== void 0 && n.length > o ? d(o) : d((r) => r >= n.length ? R(o, n) : r);
  }, [
    o,
    n
  ]);
  const y = () => {
    v((r) => !r);
  }, k = () => {
    v(!1);
  }, W = () => {
    if (p && o === void 0)
      y();
    else {
      const r = n[a];
      r.onClick && r.onClick(r);
    }
  }, G = (r, c) => {
    k(), g && g(r, c), o === void 0 && d(c), r.onClick && r.onClick(r);
  };
  return /* @__PURE__ */ f(L, {
    children: [
      /* @__PURE__ */ f(J, {
        ...E,
        ref: F,
        children: [
          /* @__PURE__ */ l(D, {
            className: "split-left-button",
            variant: h,
            flavor: e,
            disabled: i || ((w = n[a]) == null ? void 0 : w.disabled),
            loading: u,
            loadingSize: O,
            ...t,
            ...z,
            onClick: W,
            children: p && o === void 0 ? p : /* @__PURE__ */ f($, {
              children: [
                (B = n[a]) == null ? void 0 : B.icon,
                (M = n[a]) == null ? void 0 : M.title
              ]
            })
          }),
          /* @__PURE__ */ l(oo, {
            "aria-label": p ? `${p} options` : "options",
            className: "split-right-button",
            variant: h,
            flavor: e,
            disabled: i || u,
            ...t,
            ...A,
            onClick: y,
            $open: m,
            ref: C,
            children: /* @__PURE__ */ l(_, {})
          })
        ]
      }),
      /* @__PURE__ */ l(U, {
        anchorEl: C.current,
        open: m,
        onClose: k,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        transformOrigin: {
          // 8 pixels under the anchor
          vertical: -8,
          horizontal: "right"
        },
        ...j,
        children: n.map((r, c) => {
          const S = /* @__PURE__ */ l(I, {
            onClick: () => G(r, c),
            disabled: r.disabled,
            $flavor: r.flavor,
            "aria-label": r.title,
            ...r == null ? void 0 : r.MenuItemProps,
            children: /* @__PURE__ */ f($, {
              children: [
                r.icon,
                r.title
              ]
            })
          }, r.title);
          return r.tooltip ? /* @__PURE__ */ l(X, {
            title: r.tooltip,
            children: /* @__PURE__ */ l("span", {
              children: S
            })
          }, `${r.title}-tooltip`) : S;
        })
      })
    ]
  });
});
export {
  So as default
};
